import { QuestionModel } from "app/services/api/types/forms/models/QuestionModel";
import React from "react";
import { View } from "react-native";
import { AssessmentQuestionProvider } from "../context/AssessmentQuestionContext";
import { AssessmentQuestionHeader } from "../atoms/AssessmentQuestionHeader";
import { AssessmentQuestionInstructions } from "../atoms/AssessmentQuestionInstructions";
import { AssessmentQuestionField } from "../atoms/AssessmentQuestionField";
interface Props {
  question: QuestionModel;
}
const AssessmentQuestion = React.forwardRef<unknown, Props>(
  ({ question }, ref) => {
    return (
      <AssessmentQuestionProvider question={question}>
        <View>
          <AssessmentQuestionHeader />
          <AssessmentQuestionInstructions />
          <AssessmentQuestionField />
        </View>
      </AssessmentQuestionProvider>
    );
  },
);

AssessmentQuestion.displayName = "AssessmentQuestion";
export { AssessmentQuestion };
